<template>
  <Header/>
  <Slider/>
  <div class="main_m">
    <!--内容-->
    <div class="article">
      <div class="main_text">
        <h1>{{ domTitle }}</h1>
      </div>
      <ol>
        <li v-for="(item, index) in dataList" :key="index">
          <a :href="'/#/detail?id=' + item.ID" target='_blank'
             :title='item.post_title'>
            <h1>{{ item.post_title }}</h1>
            <span>[{{ item.post_date.split(" ")[0] }}]</span>
          </a>
        </li>
      </ol>
      <div style="clear: both"></div>
      <PageFen :currentPage="pageNow" :showItemPerPage="6" :totalPage="pageTotal" :callBack="_pageChange"/>

    </div>
    <div style="clear: both"></div>
  </div>
  <Footer/>
</template>

<script>
import Footer from "@/components/Footer"
import Header from "@/components/Header"
import Slider from "@/components/Slider"
import PageFen from "@/components/PageFen"
import http from "@/util/http"

export default {
  name: "ListView",
  components: {PageFen, Slider, Header, Footer},
  data() {
    return {
      queryData: {
        page: 1,
        parent: undefined
      },
      pageNow: 1,
      pageTotal: 12,
      domTitle: undefined,
      dataList: [],
      navList: [
        {
          id: 0,
          pathName: 'home',
          select: true,
          path: '/',
          label: '首页'
        },
        {
          id: 1,
          pathName: 'huiYuanZhongXin',
          select: false,
          path: '/#/huiYuanZhongXin',
          label: '会员中心'
        },
        {
          id: 2,
          pathName: 'xieHuiGaiKuang',
          select: false,
          path: '/#/xieHuiGaiKuang',
          label: '协会概况'
        },
        {
          id: 3,
          pathName: 'xinWenZiXun',
          select: false,
          path: '/#/xinWenZiXun',
          label: '新闻资讯'
        },
        {
          id: 4,
          pathName: 'hangYeDongTai',
          select: false,
          path: '/#/hangYeDongTai',
          label: '行业动态'
        },
        {
          id: 5,
          pathName: 'xinXiZhongXin',
          select: false,
          path: '/#/xinXiZhongXin',
          label: '信息中心'
        }
      ]
    }
  },
  mounted() {
    this._domTitle()
  },
  methods: {
    _pageChange(e) {
      this.queryData.page = e
      this._getList()
    },
    _domTitle() {
      const routeName = this.$route.name
      for (const i in this.navList) {
        if (this.navList[i].pathName === routeName) {
          this.domTitle = this.navList[i].label
          this.queryData.parent = this.navList[i].id
          break
        }
      }
      this._getList()
    },
    _getList() {
      http.get('listPage', {
        parent: this.queryData.parent,
        page: this.queryData.page
      })
          .then((res) => {
            if (res.data.status === 0) {
              this.dataList = res.data.data.list
              this.pageTotal = res.data.data.pageTotal
            }
          })
    },
  }
}
</script>

<style scoped>
h1 {
  font-weight: bold;
}
</style>